import React, { forwardRef } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import cn from "classnames";
import classNames from "classnames";

export interface IInput {
  type?: "text" | "email" | string;
  id: string;
  name: string;
  autoComplete?: string;
  className?: string;
  onChange?: (e: any) => void;
  value?: string;
  defaultValue?: string;
  error?: string;
  placeholder?: string;
  rows?: number;
  cols?: number;
  required?: boolean;
  testId?: string;
  reserveSpaceForError?: boolean;
}

const Input = forwardRef<HTMLInputElement, IInput>(
  (
    {
      error,
      type = "text",
      id,
      name,
      autoComplete,
      className = "",
      onChange,
      value,
      defaultValue,
      placeholder,
      rows,
      cols,
      required,
      testId = "input",
      reserveSpaceForError = true,
    },
    ref
  ) => {
    // const variant = rows || cols ? 'textarea' : 'input';
    // const InputElement: JSX.Element;//as keyof JSX.IntrinsicElements;

    const props = {
      type,
      id,
      name,
      onChange,
      value,
      autoComplete,
      defaultValue,
      placeholder,
      rows,
      cols,
      required,
      className: cn({
        "block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm":
          true,
        [className]: Boolean(className),
      }),
    };
    return (
      <div>
        <div className="input-wrapper">
          {rows || cols ? (
            <textarea {...props} data-test-id={testId} />
          ) : (
            <input {...{ ...props, ref }} data-test-id={testId} />
          )}
          {error && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <ExclamationCircleIcon
                className="h-5 w-5 text-red-500"
                aria-hidden="true"
              />
            </div>
          )}
        </div>
        <p
          className={classNames("text-sm text-red-500", {
            "mt h-5": reserveSpaceForError,
          })}
          id="email-error"
        >
          {error || ""}
        </p>
      </div>
    );
  }
);

export { Input };
